export const PHONE_NUMBER = "971506769007";
export const PHONE_DISPLAY = "+971 50 676 9007";
export const EMAIL = "resetsanctuaryofficial@gmail.com";
export const INSTAGRAM = "@resetsanctuaryofficial";
export const INSTAGRAM_URL = "https://instagram.com/resetsanctuaryofficial";
export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_647434da-5bc3-461f-ac1a-e2055210bf41/artifacts/qtqdoxb0_file_00000000cb3471f4a3efeba69da3e1a8.png";

// Build a WhatsApp deep link with a pre-filled message so Aditya sees source context.
export const waUrl = (message) => {
    if (!message) return `https://wa.me/${PHONE_NUMBER}`;
    return `https://wa.me/${PHONE_NUMBER}?text=${encodeURIComponent(message)}`;
};

// Plain link for nav / generic Reserve buttons.
export const WHATSAPP_URL = waUrl(
    "Hi Aditya, I'd like to reserve a session at The Reset Sanctuary.",
);

// Share link: opens user's own WhatsApp with a referral message they can forward.
export const SHARE_URL = `https://wa.me/?text=${encodeURIComponent(
    "The Reset Sanctuary — Recovery Through Precision Sound Recovery. Al Hamra, RAK & Al Furjan, Dubai. Reserve via WhatsApp: https://wa.me/" +
        PHONE_NUMBER,
)}`;
